export default {
  h1_services: "خدمات هوش مصنوعی برای پزشکان",
  Services: "سرویس‌ها",
  eduServices: "دوره‌ها",
  AIServices: "سرویس‌ها",
  mg: "ماموگرافی",
  dx: "رادیوگرافی قفسه سینه و فلور",
  // rf: "رادیوگرافی‌ها",
  "Go to service": "رفتن به سرویس",
  "Service banner text":
    "تأثیر پیاده‌سازی هوش مصنوعی در سازمان خود را محاسبه کنید",
  Calc: "محاسبه",
  "Services title": "لیست سرویس‌ها | " + process.env.VUE_APP_INSTALL_NAME,
  "No description service": "توضیحی وجود ندارد",
  "Services cannot loading":
    "سرویس موقتاً در دسترس نیست. بعداً دوباره تلاش کنید",
  "Cash calc title": "محاسبه صرفه‌جویی | " + process.env.VUE_APP_INSTALL_NAME,
  "Cash calc": "محاسبه صرفه‌جویی",
  "Cash calc desc": "چقدر منابع با استفاده از هوش مصنوعی صرفه‌جویی می‌شود",
  "Cash calc desc about":
    "اطلاعات مربوط به سازمان خود را وارد کنید. پس از خروج از محاسبه‌گر، داده‌ها حذف خواهند شد.",
  "Average cash": "متوسط حقوق ماهانه پزشک رادیولوژیست",
  "Study calc count": "تعداد مطالعات در سازمان شما در ماه",
  mmg: "ماموگرافی",
  ddx: "رادیوگرافی قفسه سینه",
  ct: "سی‌تی قفسه سینه",
  "Start calc": "شروع محاسبه",
  economy: "صرفه‌جویی",
  rub: " روبل",
  "calc time": " ساعت",
  "Calc summary": "جمع کل در سال",
  "Without AI": "بدون هوش مصنوعی",
  "With AI": "با هوش مصنوعی",
  "Count calc short": "تعداد ",
  "Calc in Year": " در سال",
  "Calc item 1": "توصیف <br /> 1 مطالعه، دقیقه",
  "Calc item 2": "هزینه توصیف <br />1 مطالعه، روبل",
  "Calc item 3": "هزینه برای <br />توصیف",
  "Calc item 4": "زمان برای <br />توصیف، ساعت",
  mmg__count: "ماموگرافی",
  ddx__count: "رادیوگرافی / فلورографی",
  ct__count: "سی‌تی",
  "Calc info": "روش محاسبه",
};
